export default __webpack_public_path__ + "static/media/LOCKETGO_LOGO_RVB-Noir.ecef7a0e.svg";